// src/components/ui/QuantityStepper/index.tsx
import Icon from "../Icon";
import { Wrapper, StepButton, Value } from "./styles";

interface QuantityStepperProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  size?: "sm" | "md";
}

export default function QuantityStepper({
  value,
  onChange,
  min = 0,
  max = 99,
  size = "md",
}: QuantityStepperProps) {
  const sm = size === "sm";
  return (
    <Wrapper $sm={sm}>
      <StepButton
        $sm={sm}
        aria-label="Diminuir quantidade"
        disabled={value <= min}
        onClick={() => onChange(Math.max(min, value - 1))}
      >
        <Icon name="minus" size={sm ? 15 : 17} strokeWidth={2.4} />
      </StepButton>
      <Value $sm={sm}>{value}</Value>
      <StepButton
        $sm={sm}
        aria-label="Aumentar quantidade"
        disabled={value >= max}
        onClick={() => onChange(Math.min(max, value + 1))}
      >
        <Icon name="plus" size={sm ? 15 : 17} strokeWidth={2.4} />
      </StepButton>
    </Wrapper>
  );
}
